import { useMemo } from 'react';
import { useLang } from 'hooks/lang';

import { Modal } from 'components/Blocks';

import { RequestChangeForm } from './RequestChange';
import { TeamChangeRequested } from './ChangeRequested';
import { ReviewTeamChangeRequest } from './ReviewRequest';

import { useUser } from 'hooks/user';
import { useProjectProfile } from '../../context';

import { cascadeEval } from 'utils/conditions';

import { ProjectOptionOverlayProps } from '../createProjectOption';

export function TeamChangeModal({ close, isOpen }: ProjectOptionOverlayProps) {
  const { t } = useLang();

  const user = useUser();

  const { project } = useProjectProfile();

  const Component = useMemo(
    () =>
      cascadeEval([
        {
          is: !project.teamChangeRequest,
          then: () => RequestChangeForm,
        },
        {
          is: !!project.teamChangeRequest && user.team.id === project.teamResponsible,
          then: () => TeamChangeRequested,
        },
        {
          is: user.team.id === project.teamChangeRequest?.toTeam,
          then: () => ReviewTeamChangeRequest,
        },
      ]),
    [project.teamChangeRequest, project.teamResponsible, user.team],
  );

  return (
    <Modal isOpen={isOpen} close={close} title={t('change-project-team?')} width="min(90vw, 650px)">
      <Component />
    </Modal>
  );
}
